/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {Box, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {BrandLogo} from '../../../components/icons'
import {HOME_HREF} from '@salesforce/retail-react-app/app/constants'

const CheckoutHeader = () => {
    return (
        <Box bgColor="headerBgColor" color={'white'} className="cr-checkout-header" py={'11px'}>
            <Flex align="center" justify="center">
                <Link href={HOME_HREF} title="Back to homepage">
                    <BrandLogo
                        width={{base: '35px', md: '45px'}}
                        height={{base: '24px', md: '32px'}}
                    />
                </Link>
            </Flex>
        </Box>
    )
}

export default CheckoutHeader
